const GetActorsByIds = `query GetActorsByIds($filter:ModelsFilter=null,$first:Int=null){models_v2(filter:$filter,first:$first){items{id name online linkVX(internal:true)avatar(ageRating:16){url(size:w640)}}}}`;

const GetVideosByIds = `query GetVideosByIds($ids:[Int!]!){videos_v2(filter:{ids:$ids}){items{title linkVX(internal:true)duration preview{id aspectRatio images(size:w320,placeholder:true){size url}}model{id linkVX(internal:true)name}}}}`;

export {
    GetActorsByIds,
    GetVideosByIds,
};
